/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: catalog.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog Main Component, Redirects From side-menu.js Are Met Here.
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import SideMenu from "./sideMenu/SideMenu";
import FolderManagement from "./modal/folderManagement";
import TreeLinkFolder from "./modal/treeLinkFolder";
import AddFolder from "./modal/addFolder";
import Werkregels from "./tableContext/werkregels/Main";

import { msalAuth } from "../../api/msal/MsalAuthProvider";

const Settings = (props) => {
  let compont;
  var tab = props.location.componentName;

  const [user, setUser] = useState(null);

  useEffect(async () => {
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenRedirect(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }

      if (window.$catalog_management_units_token) {
        var user = await msalAuth.getAccount();
        await setUser(user);
      } else {
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }
    }
  });

  if (
    props.history.location.pathname.split("/")[2] !=
    props.location.componentName
  ) {
    tab = props.history.location.pathname.split("/")[2];
  }
  var treekey;
  switch (tab) {
    case "werkregels":
      compont = <Werkregels {...props} />;
      break;

    default:
      return <Redirect to="/settings/werkregels" />;
  }

  return (
    <div className="mt-5">
      <div className="clearfix">
        <div className="float-left w-30" id="menu-left">
          <SideMenu menuName="settings" tabName={tab} treekey={treekey} />
          <FolderManagement treekey={treekey} />
          {treekey && true && treekey !== "financial" && treekey !== "gebruikersbeheer" &&
          treekey !== "nature-protection" ? (
            <TreeLinkFolder
              treekey={treekey}
              menuName="settings"
              tabName={tab}
              buttonId={tab + "-koppel-aan-folder"}
            />
          ) : null}
          <AddFolder treekey={treekey} />
        </div>
        <div className="float-left ml-5 w-70" id="content-mid">
          {compont}
        </div>
      </div>
    </div>
  );
};

export default Settings;
